import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { REQUEST_QUOTE_RESET } from "../constants/requestQuoteConstants";
import { useDispatch, useSelector } from "react-redux";
import { createQuoteRequest } from "../actions/requestQuoteAction";
import emailjs from "emailjs-com";
import swal from "sweetalert";

const NewsLetter = ({ history }) => {
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const form = useRef();

  const createQuote = useSelector((state) => state.createQuote);
  const {
    success: successRequest,
    loading: loadingRequest,
    error: errorRequest,
  } = createQuote;

  const [errorCreate1, seterrorCreate1] = useState(false);

    useEffect(() => {
        if (errorRequest) {
        seterrorCreate1(true);
        }
        setTimeout(() => {
        seterrorCreate1(false);
        }, 1000);
    }, [errorRequest]);


    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 5000);
        return () => clearTimeout(timer);
    }, []);

  if (successRequest) {
    swal({
      title: "Your Request have been submitted successfully!",
      icon: "success",
      button: "Close",
    });
  }

  if (errorCreate1) {
    swal({
      title: `${errorRequest}`,
      icon: "error",
      button: "Close",
    });
  }

    const handleClose = () => setIsVisible(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [company, setCompany] = useState("");
    const [designation, setDesignation] = useState("");
    const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    if (successRequest === true) {
      setIsVisible(false);
      dispatch({
        type: REQUEST_QUOTE_RESET,
      });
      setName("");
      setEmail("");
      setPhone("");
      setCompany("");
      setDesignation("");
    }


  }, [dispatch, successRequest, history, setIsVisible]);

  const submitHandler = (e) => {
    e.preventDefault(e);
    // dispatch(createQuoteRequest(companyName, email, service, description));
    // emailjs
    //   .sendForm(
    //     "service_czlj7hs",
    //     "template_sbym0r6",
    //     form.current,
    //     "LSzAkP5R6YerQQpXk"
    //   )
    //   .then(
    //     (result) => console.log(result.text),
    //     (error) => console.log(error.text)
    //   );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // console.log("Subscribed Data:", formData);
    // Send to Mailchimp, Microsoft Forms, backend, etc.
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div>
      <Modal
        show={isVisible}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="rfq-modal">
        <Modal.Header closeButton>
          <Modal.Title>Stay Connected with Outcess</Modal.Title>
          {/* <Modal.Title>            Subscribe to the Outcess Newsletter for the latest updates, industry
          insights, and exclusive announcements delivered straight to your inbox.</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
            <form ref={form} onSubmit={submitHandler}>
                <input
                    type="text"
                    placeholder="Full Name"
                    required
                    name="name"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <input
                    type="email"
                    placeholder="Email Address"
                    required
                    name="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Phone Number (Optional)"
                    name="phone"
                    id="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Company Name (Optional)"
                    name="company"
                    id="company"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Designation (Optional)"
                    name="designation"
                    id="designation"
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                />

                <div style={{ display: "flex", alignItems: "space-between", margin: "10px 0" }}>
                <input
                    type="checkbox"
                    id="privacy"
                    checked={agreed}
                    onChange={() => setAgreed(!agreed)}
                    required
                    style={{ marginRight: "0.5rem" }}
                    />
                    <label htmlFor="privacy" style={{ margin: 0 }}>
                        I agree to the{" "}
                        <a
                        href="https://outcess.com/data-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#0056b3", textDecoration: "underline" }}
                        >
                        Privacy Policy
                        </a>
                    </label>
                </div>

                <div className="rfq-modal-btn">
                <button
                    className="ccsnl-btn"
                    disabled={loadingRequest && true}
                    type="submit"
                    value="Request">
                    {loadingRequest ? "submiting Request..." : "Subscribe Now"}
                </button>
                </div>
            </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NewsLetter;
